import './index.css'
import { BookingModule } from './component.tsx'

customElements.define('booking-module', BookingModule)
